import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaChevronDown,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./Layout.css";

function Layout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
    if (drawerOpen) setSubmenuOpen(false);
  };

  const toggleSubmenu = () => {
    setSubmenuOpen(!submenuOpen);
  };

  /* =========================
     TOP BAR SCROLL LOGIC
  ========================= */
  useEffect(() => {
    const topBar = document.querySelector(".top-bar");
    const header = document.querySelector(".header");

    if (!topBar || !header) return;

    const handleScroll = () => {
      if (window.scrollY > 10) {
        topBar.style.display = "none";
        header.style.top = "0";
      } else {
        topBar.style.display = "block";
        header.style.top = "30px";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="layout">
      {/* ================= TOP BAR ================= */}
      <div className="top-bar">
        <div className="top-bar-inner">
          <div className="top-bar-left">
            <span>📞 +91 7200039384</span>
            <span>✉ info@aerlis.in</span>
            <span>🕘 Monday - Saturday : 9.30am - 6pm</span>
          </div>

          <div className="top-bar-right">
            <NavLink to="/terms" className="top-link">
              Terms & Conditions
            </NavLink>
            <NavLink to="/privacy" className="top-link">
              Privacy Policy
            </NavLink>

            <a
              href="https://x.com"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaXTwitter />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              className="social-icon"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      {/* ================= HEADER ================= */}
      <header className="header">
        <div className="header-container">
          <img src="/logo56.png" alt="Logo" className="logo-img" />

          {/* DESKTOP MENU */}
          <nav className="nav-tabs">
            <NavLink to="/" end className="tab">
              Home
            </NavLink>

            <NavLink to="/about-us" className="tab">
              About Us
            </NavLink>

            <NavLink to="/our-services" className="tab">
              Our Services
            </NavLink>

            {/* ✅ NEW GALLERY PAGE */}
            <NavLink to="/gallery" className="tab">
              Gallery
            </NavLink>

            <div className="careers-menu">
              <span className="tab">Careers</span>
              <div className="submenu">
                <NavLink
                  to="/careers/internship"
                  className="submenu-link"
                >
                  Internship
                </NavLink>
                <NavLink to="/careers/jobs" className="submenu-link">
                  Jobs
                </NavLink>
              </div>
            </div>

            <NavLink to="/contact" className="tab">
              Contact
            </NavLink>
          </nav>

          {/* MOBILE MENU ICON */}
          <FaBars className="menu-btn" onClick={toggleDrawer} />
        </div>
      </header>

      {/* ================= OVERLAY ================= */}
      <div
        className={`drawer-overlay ${drawerOpen ? "active" : ""}`}
        onClick={toggleDrawer}
      />

      {/* ================= MOBILE DRAWER ================= */}
      <aside className={`drawer ${drawerOpen ? "open" : ""}`}>
        <div className="drawer-close" onClick={toggleDrawer}>
          <FaTimes />
        </div>

        <NavLink to="/" onClick={toggleDrawer} className="drawer-link">
          Home
        </NavLink>

        <NavLink
          to="/about-us"
          onClick={toggleDrawer}
          className="drawer-link"
        >
          About Us
        </NavLink>

        <NavLink
          to="/our-services"
          onClick={toggleDrawer}
          className="drawer-link"
        >
          Our Services
        </NavLink>

        {/* ✅ NEW GALLERY LINK (Mobile) */}
        <NavLink
          to="/gallery"
          onClick={toggleDrawer}
          className="drawer-link"
        >
          Gallery
        </NavLink>

        {/* MOBILE SUBMENU */}
        <div className="drawer-link drawer-parent" onClick={toggleSubmenu}>
          Careers
          <FaChevronDown
            className={`arrow ${submenuOpen ? "rotate" : ""}`}
          />
        </div>

        <div
          className={`drawer-submenu ${submenuOpen ? "open" : ""}`}
        >
          <NavLink
            to="/careers/internship"
            onClick={toggleDrawer}
            className="drawer-sublink"
          >
            Internship
          </NavLink>

          <NavLink
            to="/careers/jobs"
            onClick={toggleDrawer}
            className="drawer-sublink"
          >
            Jobs
          </NavLink>
        </div>

        <NavLink
          to="/contact"
          onClick={toggleDrawer}
          className="drawer-link"
        >
          Contact
        </NavLink>
      </aside>

      {/* ================= PAGE CONTENT ================= */}
      <main className="content">{children}</main>

      {/* ================= FOOTER ================= */}
      <footer className="footer">
        © 2025 AERLIS GRO IMF PRIVATE LIMITED. ALL RIGHTS RESERVED.
      </footer>
    </div>
  );
}

export default Layout;
